import React, { useEffect, useState } from 'react'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/router'
import { Box, Tab, TabList, Tabs } from '@alto-avios/alto-ui'

import { usePlatformRoutes } from '~/context/platform'
import { type ProductSlug } from '~/schemas/browserUrl'

import styles from './SearchPageNavigation.module.scss'

type Props = {
  activeSlug?: ProductSlug
  enabledSlugs?: Array<ProductSlug>
}

const SearchPageNavigation = ({ activeSlug, enabledSlugs }: Props) => {
  const t = useTranslations('common.product_labels')
  const router = useRouter()
  const { createRoutePath } = usePlatformRoutes()
  const [isHydrated, setIsHydrated] = useState(false)

  useEffect(() => {
    setIsHydrated(true)
  }, [])

  const productLabels: Record<ProductSlug, string> = {
    hotels: t('hotels'),
    cars: t('car_hire'),
    experiences: t('experiences'),
    flights: t('flights'),
  }
  const productIcons: Record<ProductSlug, string> = {
    hotels: 'hotel',
    cars: 'car',
    experiences: 'tickets',
    flights: 'plane',
  }
  // Temporary for e2e tests while not in higher envs
  // should remove this once feature is live and update tests to use new (alto generated) ids
  const legacyTabIds: Record<ProductSlug, string> = {
    hotels: 'hotels',
    cars: 'carhire',
    experiences: 'experiences',
    flights: 'flights',
  }

  return (
    <Box
      width="100%"
      position="relative"
      justifyContent="center"
      alignItems="center"
      className={styles.tabsWrapper}
    >
      <Tabs
        styleVariant="contained"
        selectedKey={activeSlug}
        onSelectionChange={(key) => {
          router.push(
            {
              pathname: createRoutePath(`/${key}`),
            },
            undefined,
            { scroll: false }
          )
        }}
      >
        <TabList>
          {enabledSlugs?.map((slug) => (
            <Tab id={slug} key={slug} iconName={isHydrated ? productIcons[slug] : undefined}>
              <span id={legacyTabIds[slug]}>{productLabels[slug]}</span>
            </Tab>
          ))}
        </TabList>
      </Tabs>
    </Box>
  )
}

export default SearchPageNavigation
